import React, { useContext, useEffect, useMemo, useState } from 'react';
import { TestTagContext } from '../contexts/test-tag.context';
import type { SharedTestIdProps } from '../contexts/shared-test-id.context';
import { SharedTestIdContext } from '../contexts/shared-test-id.context';

const useSharedTestId = (sharedId: string, wrappedMarkup: React.JSX.Element) => {
  const [isTesting, setIsTesting] = useState(false);
  const testingContext = useContext(TestTagContext);
  const sharedData = useMemo<SharedTestIdProps>(() => {
    return {
      sharedId,
    };
  }, [sharedId]);

  useEffect(() => {
    setIsTesting(testingContext?.isTesting ?? false);
  }, [testingContext]);

  return (
    <>
      {!isTesting ? (
        wrappedMarkup
      ) : (
        <SharedTestIdContext.Provider value={sharedData}>{wrappedMarkup}</SharedTestIdContext.Provider>
      )}
    </>
  );
};

const useSharedTestIdContext = () => {
  return useContext(SharedTestIdContext);
};

export { useSharedTestId, useSharedTestIdContext };
